<ng-container *ngIf="organizedActivity$ | async as organizedActivity">
    <organized-activity
        [organizedActivity]="organizedActivity"
        [darkMode]="windowService.darkMode$ | async"
    ></organized-activity>
</ng-container>
